<ol class="breadcrumb float-sm-right">
  <li
    class="breadcrumb-item"
    *ngFor="let item of getBreadcrumb(); let isLast = last"
    [ngClass]="{ active: isLast }"
  >
    <a *ngIf="!isLast" [routerLink]="[item.link]">{{ item.title }}</a>
    <span *ngIf="isLast">{{ item.title }}</span>
  </li>
</ol>
